module.exports = __webpack_public_path__ + "static/media/photo-set.0d19c133.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/markers/photo-set.svg
// module id = 204
// module chunks = 0